import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import { computed, onMounted } from "vue";
import MainLayout from "@/layouts/MainLayout.vue";
import CalculatorLayout from "@/layouts/CalculatorLayout.vue";
import { useRoute } from "vue-router";
import EmptyLayout from "@/layouts/EmptyLayout.vue";
import { useUserStore } from "@/stores/userStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const layoutsMap: Record<string, object> = {
  main: MainLayout,
  calculator: CalculatorLayout,
  empty: EmptyLayout,
};

const route = useRoute();
const layoutComponent = computed(() => {
  const metaLayout: string =
    (route.meta.layout as string | undefined) ?? "main";

  return layoutsMap[metaLayout] ?? MainLayout;
});

const layoutProps = computed(() => ({
  withOverflow: route.meta.withOverflow,
  showBlogBtn: route.meta.showBlogBtn,
  showBgImage: route.meta.showBgImage,
}));

onMounted(async () => {
  const authStore = useUserStore();
  authStore.loadUserFromStorage();
  if (authStore.user !== null) {
    await authStore.updateUserInfo(true);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(layoutComponent.value), _normalizeProps(_guardReactiveProps(layoutProps.value)), {
    default: _withCtx(() => [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, { include: "ChineseCalendarView" }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: _unref(route).name
            }))
          ], 1024))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}
}

})